import "./index.scss";

const SectionClientSlider = () => {};

export default SectionClientSlider;
